var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92852 10.6794C2.38403 10.2031 1.95774 9.60671 1.6833 8.93736C1.40887 8.26801 1.2938 7.54402 1.3472 6.82256C1.4006 6.10111 1.621 5.40195 1.991 4.78029C2.36099 4.15864 2.87045 3.63152 3.47913 3.24055C4.08781 2.84959 4.77906 2.60549 5.49827 2.52754C6.21749 2.44959 6.94498 2.53991 7.6233 2.79138C8.30161 3.04284 8.91218 3.44857 9.40677 3.97651C9.90137 4.50445 10.2665 5.14015 10.4732 5.83341H11.6665C12.3146 5.83333 12.9452 6.0431 13.4641 6.43132C13.983 6.81954 14.3622 7.36534 14.545 7.98706C14.7279 8.60878 14.7045 9.27299 14.4783 9.8803C14.2522 10.4876 13.8355 11.0054 13.2905 11.3561",
    stroke: "#6F6D7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.5V9.16667M8.00016 9.16667L5.3335 11.8333M8.00016 9.16667L10.6668 11.8333",
    stroke: "#6F6D7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.21e1f8c9276825ba732f626edbe86d3e.svg";
export { ForwardRef as ReactComponent };